module.exports = __webpack_public_path__ + "img/comparator.367c5aab.svg";